import {contentElement} from "../../helper/content-element/content-elements";

export const createSustainabilityContext = (currentItem: any,
                                            staticLinks: any): SustainabilityContext | null => {
    if(!currentItem?.sustainability) return null;
    return {
        ...currentItem?.sustainability,
        features: extractFeatures(currentItem?.sustainability.categories),
        staticLinks: extractStaticLinks(staticLinks),
        contentElements: extractContentElements(),
        selectedItemNumber: currentItem?.itemNumber
    };
};

const extractFeatures = (categories: SustainabilityCategory[]): string[] => {
    if(!categories) return [];
    return categories
        .filter(category => !!category.icon)
        .map(category => category.icon.featureName);
};

const extractStaticLinks = (staticLinks: any): Record<string, string> => {
    return {
        sustainabilityGoalLink: staticLinks.sustainabilityGoalUrl,
    };
};

const extractContentElements = (): Record<string, string> => {
    return {
        accordionHeadline: contentElement("ada_accordion_headline_sustainability"),
        sustainabilityIntroduction: contentElement('ada_sustainability_categories_introduction'),
        toCategoryDetails: contentElement('ada_sustainability_categories_learn_more_text'),
        sustainabilityGoalIntroduction: contentElement('ada_sustainability_goal'),
        sustainabilityGoalLink: contentElement('ada_sustainability_goal_link_text')
    };
};

//TODO maybe move this interface definitions to a separate file
export interface SustainabilityContext {
    categories: SustainabilityCategory[];
    staticLinks: Record<string, string>;
    contentElements: Record<string, string>;
    features: string[];
    selectedItemNumber: string;
    circularityIdLink?: string;
}

export interface SustainabilityCategory {
    name: string;
    text: string;
    icon: SustainabilityIcon;
    attributes: SustainabilityAttribute[];
}

export interface SustainabilityAttribute {
    name: string;
}

export interface SustainabilityIcon {
    featureName: string;
}
